import { Button } from "@devhop/ui";
import { HelpCircle, PlusIcon } from "lucide-react";

type ServiceStandardMappingToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onStartTour?: () => void;
};

export function ServiceStandardMappingToolbar({
  canManage,
  onCreate,
  onStartTour,
}: ServiceStandardMappingToolbarProps) {
  return (
    <div className="mb-4 flex items-center justify-between">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="font-bold text-2xl">ການຜູກມາດຕະຖານບໍລິການ</h1>
          <Button
            variant="ghost"
            size="icon"
            className="size-7 rounded-full"
            onClick={onStartTour}
          >
            <HelpCircle className="size-5" />
          </Button>
        </div>
        <p className="mt-1 text-muted-foreground text-sm">
          ຈັດການການຜູກມາດຕະຖານບໍລິການກັບຕໍາແໜ່ງ, Checklist, QC Standard ແລະ KPI
        </p>
      </div>
      {canManage && (
        <div data-tourid="mapping-toolbar">
          <Button onClick={onCreate}>
            <PlusIcon className="mr-2 h-4 w-4" />
            ສ້າງການຜູກໃໝ່
          </Button>
        </div>
      )}
    </div>
  );
}
